import { Component, Input } from '@angular/core';
import * as Models from '@app/models/ai.model';

@Component({
	selector: 'ai-answer',
	templateUrl: './answer.component.html',
	styleUrls: ['./answer.component.scss'],
})
export class AIAnswerComponent {
	@Input() value: Models.AIAnswerModel;
}

